var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Switcher from '../Switcher';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleAcceptFactorDecrease as toggleAcceptFactorDecreaseAction, toggleAcceptFactorIncrease as toggleAcceptFactorIncreaseAction } from '../../../actions/creators/BettingMode';
function AutoConfirm(props) {
    var bettingMode = props.bettingMode;
    var toggledIncClassName = bettingMode.acceptIncrease ? 'toggle-div__inner toggled' : 'toggle-div__inner';
    var toggledDecClassName = bettingMode.acceptDecrease ? 'toggle-div__inner toggled' : 'toggle-div__inner';
    return (_jsxs("div", __assign({ className: 'auto-confirm' }, { children: [_jsxs("h4", __assign({ className: 'auto-confirm__title' }, { children: [props.autoConfirmTxt, ":"] })), _jsx(Switcher, { switcherTxt: props.increaseTxt, onclick: props.toggleAcceptFactorIncreaseAction, class: toggledIncClassName }), _jsx(Switcher, { switcherTxt: props.decreaseTxt, onclick: props.toggleAcceptFactorDecreaseAction, class: toggledDecClassName })] })));
}
AutoConfirm.propTypes = {
    toggleAcceptFactorIncreaseAction: PropTypes.func.isRequired,
    toggleAcceptFactorDecreaseAction: PropTypes.func.isRequired,
};
var mapStateToProps = function (state) { return ({
    bettingMode: state.application.get('bettingMode')
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    toggleAcceptFactorIncreaseAction: toggleAcceptFactorIncreaseAction,
    toggleAcceptFactorDecreaseAction: toggleAcceptFactorDecreaseAction
}, dispatch); };
export default connect(mapStateToProps, mapDispatchToProps)(AutoConfirm);



// WEBPACK FOOTER //
// ./src/components/sidebar/settings/AutoConfirm.jsx